import { GetApp } from "../../App"
import { Block, BlockContainer, BlockField, BlockFieldInputs, BlockRow } from "../../Components/Block"
import { CloseButton } from "../../Components/CloseButton"
import { EditGroup } from "../../Components/EditGroup"
import { Icon, Icons } from "../../Components/Icon"
import { Loading } from "../../Components/Loading"
import { GetShipData, ShipDataViewData } from "./Context"
import { ShipDataInsuranceView } from "./InsuranceView"
import { ShipDataGeneralViewProps } from "./Params"

export function ShipDataGeneralView(_: ShipDataGeneralViewProps) {
  const app = GetApp();
  const t = app.getT("ShipDataView");
  const { data, ship, attachments, editable, formEditable, edited, onEdited, save, files, saveAttachments, handleDrop, handleSelect, removeAttachment, inputRef, showAttachment, setShowAttachment, editInsurance } = GetShipData();
  return (
    <EditGroup changed={edited} editable={editable} editableFields={[
      "mmsi", "callsign", "homePort", "flag", "regNumber", "hin", "imo", "yachtBuildNumber", "yachtYachtBuilder", "yachtModelName", { name: "yachtYearBuild", type: "int" }, "yachtConstruction", "yachtDesigner", "cel", "celPersons", "ownerName", "ownerPhone", "ownerEmail", "ownerAddress", "yachtClubName", "yachtClubAddress",
      { name: "insurances", array: true, type: "object", fields: ["id", "insuranceType", "insuranceCompany", "insuranceNumber"] },
    ]} onSave={save}
    >
      {/* General ship data */}
      <BlockContainer>
        <Block className="block_field_50 ship-data-general">
          <BlockRow>
            <h3>{t("general")}</h3>
          </BlockRow>
          <BlockRow>
            <BlockField label={t("mmsi")} className="block_field_small_10">
              <input defaultValue={data.mmsi} name="mmsi" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("callsign")} className="block_field_small_10">
              <input defaultValue={data.callsign} name="callsign" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("home_port")} className="block_field_small_14">
              <input defaultValue={data.homePort} name="homePort" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("flag")} className="block_field_small_14">
              <input defaultValue={data.flag} name="flag" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("reg_number")} className="block_field_small_12">
              <input defaultValue={data.regNumber} name="regNumber" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("hin")} className="block_field_small_12">
              <input defaultValue={data.hin} name="hin" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("imo")} className="block_field_small_12">
              <input defaultValue={data.imo} name="imo" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("build_number")} className="block_field_small_12">
              <input defaultValue={data.yachtBuildNumber} name="yachtBuildNumber" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("yachtbuilder")} className="block_field_small_22">
              <input defaultValue={data.yachtYachtBuilder} name="yachtYachtBuilder" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("model_name")} className="block_field_small_22">
              <input defaultValue={data.yachtModelName} name="yachtModelName" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("year")} className="block_field_small_6">
              <input defaultValue={data.yachtYearBuild} name="yachtYearBuild" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("construction")} className="block_field_small_14">
              <input defaultValue={data.yachtConstruction} name="yachtConstruction" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("designer")} className="block_field_small_14">
              <input defaultValue={data.yachtDesigner} name="yachtDesigner" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("cel")} className="block_field_small_8">
              <input defaultValue={data.cel} name="cel" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("cel_persons")} className="block_field_small_8">
              <input defaultValue={data.celPersons} name="celPersons" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>
        </Block>

        <Block className="block_field_350 ship-data-photos">
          <BlockRow>
            <h3>{t("ship_foto")}</h3>
          </BlockRow>

          {formEditable && (
            <EditGroup buttonFirst={true} changed={files.length > 0} className={"NoteView-attachment-form"} editable={true} editableFields={["attachment"]} onSave={saveAttachments}>
              {files.length === 0 && (
                <BlockRow>
                  <div className="form-field file-field" onDrop={handleDrop} onDragOver={(event) => event.preventDefault()}>
                    <label htmlFor="attachment" className="file-field-label" onClick={() => inputRef.current && inputRef.current.click()}><span>{t("file_field_drag_drop")}</span></label>
                    <input ref={inputRef} type="file" hidden accept="image/*" name="attachment" onChange={handleSelect} />
                  </div>
                </BlockRow>
              )}

              {files.length > 0 && (
                <BlockRow>
                  <div className="attachment-item">
                    <CloseButton className="attachment-remove" onClick={removeAttachment} />
                    <img src={URL.createObjectURL(files[0])} alt={files[0].name} style={{ maxWidth: "100%", maxHeight: "400px" }} />
                  </div>
                </BlockRow>
              )}

            </EditGroup>
          )}

          {attachments && attachments.length > 0 && (
            <>
              <BlockRow className="ship-photos">
                {(showAttachment >= attachments.length || (app.cloudSession() && !attachments[showAttachment].url)) ? <Loading /> : ((a) => {
                  const key = `ship-${ship.id}-attachment-${a.id}`;
                  const image = (a.contentType.startsWith("image/"));
                  const url = ShipDataViewData.attachmentUrl(app.apiClient, ship.id, a, app.cloudSession());
                  return (
                    <div key={key} className="ship-photo attachment-item">
                      {image && <img src={url} alt={a.fileName} />}
                      {formEditable && <CloseButton className="attachment-remove" onClick={removeAttachment} />}
                    </div>
                  );
                })(attachments[showAttachment])}
              </BlockRow>
              <BlockRow actions={attachments && attachments.length > 1} className="row-arrow-buttons">
                <button disabled={showAttachment < 1} onClick={() => setShowAttachment(showAttachment - 1)}className="arrow-button"><Icon icon={Icons.ArrowLeft} /></button>
                <button disabled={showAttachment >= attachments.length - 1} onClick={() => setShowAttachment(showAttachment + 1)} className="arrow-button"><Icon icon={Icons.ArrowRight} /></button>
              </BlockRow>
            </>
          )}
        </Block>

      </BlockContainer>
      {/* Owner */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("owner")}</h3>
          </BlockRow>

          <BlockRow className="owner-data">
            <BlockField label={t("owner_name")} className="block_field_small_22">
              <input defaultValue={data.ownerName} name="ownerName" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("owner_phone")} className="block_field_small_12">
              <input defaultValue={data.ownerPhone} name="ownerPhone" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("owner_email")} className="block_field_small_22">
              <input defaultValue={data.ownerEmail} name="ownerEmail" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("owner_address")} className="block_field_small_600">
              <input defaultValue={data.ownerAddress} name="ownerAddress" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>

          <BlockRow>
            <BlockField label={t("yacht_club")} className="block_field_small_22">
              <input defaultValue={data.yachtClubName} name="yachtClubName" onChange={onEdited} readOnly={!editable} />
            </BlockField>
            <BlockField label={t("yacht_club_address")} className="">
              <input defaultValue={data.yachtClubAddress} name="yachtClubAddress" onChange={onEdited} readOnly={!editable} />
            </BlockField>
          </BlockRow>
        </Block>
      </BlockContainer>

      {/* Insurances - ShipDataInsuranceView */}
      <BlockContainer>
        <Block>
          <BlockRow>
            <h3>{t("insurances")}</h3>
          </BlockRow>

          {editInsurance.items.map((insurance, index) => (
            <ShipDataInsuranceView data={insurance} editable={editable} index={index} key={insurance.id} onEdited={onEdited} removeInsurance={() => { editInsurance.removeAt(index); onEdited(); }} />
          ))}

          <BlockRow>
            <BlockFieldInputs>
              <button className="button" disabled={!editable} onClick={() => { editInsurance.add(); onEdited(); }}>
                <Icon icon={Icons.Plus} /> {t("add_insurance")}
              </button>
            </BlockFieldInputs>
          </BlockRow>

        </Block>
      </BlockContainer>
    </EditGroup>
  );
}
